<template>
  <div>
    <Icon size="28" color="#FFFFFF" type="md-notifications" @click="show" style="cursor: pointer" />
   
    <Drawer title="站内信息" :closable="false" v-model="drawerShow" width="550">
      <Collapse @on-change="test" accordion>
        <Panel  v-for="(item, index) in movieList" :key="item.id" :name="String(item.id)">
          
            <i v-if="item.status === '0'" style="color: blue;margin-right: 5px;">[未读]</i>
            <i v-if="item.status === '1'" style="color: gray;margin-right: 5px;">[已读]</i>
          {{item.title}} 
            <i style="float: right;margin-right: 10px;-webkit-transform: rotate(0deg);">{{item.createtime}}</i>
            <p slot="content">
               {{ item.content }}
            </p>
        </Panel>
        
    </Collapse>
    <Page :total="dataCount" :current="1" :page-size="20" @on-change="changePage" style="float: right;margin-top: 10px;"></Page>
     
    </Drawer>
  </div>
</template>

<script>
import { pageMessage,readMessage,haveNeverRead } from '@/api/fwsc/yearfee'
export default {
  name: 'Message',

  data() {
    return {
      drawerShow: false,
      movieList: [],
      dataCount: 0,
      index: 1,
      totalMovieList: [],

      step: "1",
      readOrNo: ['[未读]','[已读]'],
    }
  },

  props: {
    ghost: {
      type: Boolean,
      default: true
    },
    value: [String,Number]
  },

  methods: {
    show() {
      this.drawerShow = !this.drawerShow

     
      this.$emit('changetype')
      /* 可以自行查询操作 */
      
      this.changePage(this.index)
      
    },

    changePage(index) {
      console.log(index)
      this.index = index
      var page = {
        pageNo: index
      }
      pageMessage({page}).then(res => {
        this.totalMovieList = res.objList,
        this.dataCount = res.pageDesc.totalRows
        if (this.dataCount < this.pageSize){
          this.movieList = this.totalMovieList;
        }else{
          this.movieList = this.totalMovieList.slice(0,this.pageSize);
        }

      })
    },
    
    test(key) {
      
      readMessage(key).then(res => {
        haveNeverRead().then(res => {

          this.$emit('changetype');
    })
      // /* 可以自行查询操作 */
      // pageMessage().then(res => {
      //   this.totalMovieList = res.objList,
      //   this.dataCount = res.objList.length
      //   if (this.dataCount < this.pageSize){
      //     this.movieList = this.totalMovieList;
      //   }else{
      //     this.movieList = this.totalMovieList.slice(0,this.pageSize);
      //   }

      // },10000)
      })
      
    }
  }
}
</script>
